import { useTranslate } from "@tolgee/react";
import React from "react";
import { OrganisationMembershipStatus } from "../../../clients/graphqlTypes.js";

const STATUSES = ["UNACTIVATED", "ACTIVATED", "DEACTIVATED"] as const;

export function useOrganisationMembershipStatuses() {
  const { t } = useTranslate(["OrganisationProfile"]);

  const statusLabels: Record<OrganisationMembershipStatus, string> =
    React.useMemo(
      () => ({
        UNACTIVATED: t("Unactivated", { ns: "OrganisationProfile" }),
        ACTIVATED: t("Activated", { ns: "OrganisationProfile" }),
        DEACTIVATED: t("Deactivated", { ns: "OrganisationProfile" }),
      }),
      [t]
    );

  const statusOptions = React.useMemo<
    Array<{ label: string; value: OrganisationMembershipStatus }>
  >(() => {
    return STATUSES.map(status => ({
      label: statusLabels[status],
      value: status,
    }));
  }, [statusLabels]);

  return { statusLabels, statusOptions };
}
